{
  "title": "Bienvenue sur",
  "loading": "Chargement...",
  "folderView": {
    "title": "Boîte de réception"
  },
  "folderActions": {
    "applyAll": "Copier dans tous les sous-dossiers",
    "applySelected": "Copier dans les sous-dossiers sélectionnés"
  },
  "misc": {
    "logout": "Déconnexion",
    "login": "Connexion",
    "close": "Fermer"
  },
  "license": {
    "dialog": {
      "title": "Information sur la licence",
      "client": "Client",
      "domains": "Domains",
      "type": " Type de licence",
      "expiry": "Date d'expiration",
      "productGuid": "ID du produit"
    },
    "invalid": "Pas de licence valide. Veuillez vous adresser à votre administrateur système."
  },
  "permissions": {
    "isLoading": "Chargement du dossier...",
    "displayErrorDetails": "Afficher les détails de l'erreur",
    "errors": {
      "couldNotLoadError": "Impossible de charger le dossier",
      "missingExchangeFolderId": "Ce lien est incomplet. Veuillez sélectionner à nouveau le dossier dans la liste des dossiers."
    },
    "user": "Nom",
    "permissionLevel": "Niveau d'autorisation",
    "checkLabel": "Oui",
    "uncheckLabel": "Non",
    "sortAscLabel": "Trier par ordre croissant",
    "sortDescLabel": "Trier par ordre décroissant",
    "unsortedLabel": "Ne pas trier",
    "createPermissions": "Créer",
    "createPermissionsNone": "Aucun",
    "createPermissionsItems": "Éléments",
    "createPermissionsSubfolders": "Sous-dossiers",
    "createPermissionsItemsSubfolders": "Éléments + sous-dossiers",
    "readPermissions": "Lire",
    "readPermissionsNone": "Aucun",
    "readPermissionsFull": "Tous les détails",
    "editPermissions": "Modifier",
    "editPermissionsNone": "Aucun",
    "editPermissionsOwn": "Personnel",
    "editPermissionsAll": "Tout",
    "deletePermissions": "Supprimer",
    "folderPermissions": "Autorisations de dossier",
    "folderPermissionsNone": "Aucune",
    "isFolderOwner": "Propriétaire",
    "isFolderVisible": "Visible",
    "isFolderContact": "Contact",
    "modifyAction": {
      "editTitle": "Traiter",
      "addTitle": "Ajouter des autorisations",
      "closeButton": "Annuler",
      "submitButton": "Appliquer",
      "applyRecursive": "Appliquer à tous les sous-dossiers",
      "personGroup": {
        "label": "Personne",
        "noItems": "Aucune personne trouvée",
        "alreadySelected": "- Déjà sélectionné"
      },
      "levelGroup": {
        "label": "Niveau d'autorisation",
        "options": {
          "owner": "Propriétaire",
          "publishingEditor": "Éditeur de publication",
          "editor": "Éditeur",
          "publishingAuthor": "Auteur de publication",
          "author": "Auteur",
          "noneditingAuthor": "Auteur secondaire",
          "reviewer": "Réviseur",
          "contributor": "Contributeur",
          "none": "Aucune",
          "custom": "Personnalisé"
        },
        "warnings": {
          "owner": "Les propriétaires du niveau d'autorisation sélectionné peuvent accorder des autorisations à d'autres utilisateurs et peuvent éventuellement vous retirer vos autorisations."
        }
      },
      "readGroup": {
        "label": "Lecture",
        "options": {
          "none": "Aucune",
          "full": "Tous les détails"
        }
      },
      "deleteGroup": {
        "label": "Supprimer l´acce`s",
        "options": {
          "none": "Aucune",
          "own": "Personnel",
          "all": "Tout"
        }
      },
      "editGroup": {
        "label": "Modifier",
        "options": {
          "none": "Aucune",
          "own": "Personnel",
          "all": "Tout"
        }
      },
      "createGroup": {
        "label": "Créer",
        "options": {
          "createItems": "Éléments",
          "createSubfolders": "sous-dossiers"
        }
      },
      "otherGroup": {
        "label": "Autre",
        "options": {
          "folderOwner": "Propriétaire du dossier",
          "folderContact": "Contact du dossier",
          "folderVisible": "Dossier visible"
        }
      }
    },
    "actionsColumnTitle": "Actions",
    "deleteAction": {
      "buttonLabel": "Supprimer",
      "cancelLabel": "Annuler",
      "confirmTitle": "Voulez-vous vraiment supprimer l'autorisation ?"
    },
    "pagination": {
      "nextLabel": "Suivant",
      "previousLabel": "Précédent",
      "currentLabel": "Page"
    }
  },
  "toast": {
    "success": "Succès",
    "error": "Erreur",
    "warning": "Avertissement",
    "info": "Info",
    "copy": "Copier dans le presse-papiers",
    "dismiss": "Fermer",
    "unknownError": "Erreur inconnue",
    "traceId": "ID de trace",
    "timestamp": "Horodatage"
  },
  "placeholder": {
    "iconText": "Sélectionnez un dossier",
    "description": "Sélectionnez un dossier dans la liste pour voir ou modifier les autorisations directement."
  },
  "peoplePicker": {
    "errors": {
      "anErrorOccurred": "Une erreur s'est produite"
    }
  },
  "rootErrorComponent": {
    "unknownError": {
      "title": "Erreur inconnue",
      "description": "Une erreur inattendue s'est produite. Veuillez réessayer plus tard."
    },
    "backendOfflineError": {
      "title": "Backend indisponible",
      "description": "Nous ne parvenons pas à nous connecter au serveur."
    },
    "retryButtonLabel": "Réessayer"
  }
}